const helpers = {
  price: (product) => product.priceRange.minVariantPrice.amount,
  compareAtPrice: (product) =>
    product.compareAtPriceRange.minVariantPrice.amount,
  currency: (product) => product.priceRange.minVariantPrice.currencyCode,
  // onlineStoreUrl is always null until we remove password protection.
  // url: (product) => new URL(product.onlineStoreUrl).pathname,
  url: (product) => `/products/${product.handle}`,
  discontinuedRedirectUrl: (product) =>
    product.discontinuedRedirect &&
    `/products/${product.discontinuedRedirect.handle}`,
  hasOnlyDefaultVariant: (product) =>
    product.variants.length === 1 &&
    product.variants[0].title === "Default Title",
};

export default function addProductHelpers(product) {
  product.helpers = {};

  Object.entries(helpers).forEach(([key, helper]) => {
    product.helpers[key] = helper(product);
  });
  // Nest products on variants so we can get product data from variant object.
  product.variants.forEach((variant) => {
    variant.product = product;
  });
  product.group?.products?.forEach((groupProduct) => {
    addProductHelpers(groupProduct);
    groupProduct.variants.forEach((variant) => {
      variant.product = groupProduct;
    });
  });

  return product;
}
